$(function(){ 
    function messageReceived(text, id, channel){
        text=Base64.decode(text);
        var data=JSON.parse(text);
        
        if(data.namespace=="user"){
            pushUser(data);
        }
    };
    
    var pushConf={
        host: window.location.hostname,
        port: window.location.port,
        modes: "longpolling"
    };
    if (typeof window.WebSocket!="undefined" && window.WebSocket){
         pushConf.modes="websocket";
    } 
    if(typeof window.location.protocol!="undefined" && (window.location.protocol=="https" || window.location.protocol=="https:")){
        pushConf.useSSL=true;
    }
    var _pushstream = new PushStream(pushConf);
    
   /* _pushstream.onmessage = messageReceived;
    _pushstream.addChannel(_pushPrefix+Base64.decode(_pushUser));
    _pushstream.connect();*/
    
    function pushUser(data){
        var mess_id=intval(data.mpmess_id);
        if(typeof data.profile!="undefined"){
            _myProfile.updateData(data.profile);
        }
        if(mess_id==1){
            if(getCurrentPage()=="premiumshop"){
                $.goToLocation("premiumshop");
            }
        }
        if(mess_id==3){
            //premium pack!
            var attr_str="";
            if(typeof data.type_id!=="undefined"){
                $.iconPremiumTimer("deletePremium",data.type_id);
                attr_str="[data-type_id='"+data.type_id+"']";
            }
            if(attr_str!=""){
                if($("#myGameCover #premiumOne"+attr_str+":visible").length){
                    $.closeModulePage();
                }
            }
//            if(typeof data.update!="undefined"){
//                $.updatePanel();
//            }


        }
        
        
        if(mess_id==101){
            debugArr(data);
        }
        
    }
    
    
   
});


